import ContactForm from "./ContactForm";
import jQueryBridget from "jquery-bridget";
import imagesLoaded from "imagesloaded";

import jquery from "jquery";
require("jquery.cookie");
window.jQuery = jquery;
window.$ = jquery;

// Import Leaflet
import L from 'leaflet';
window.L = L;
jQueryBridget("imagesLoaded", imagesLoaded, $);

require("@fancyapps/fancybox");

require("./owl-carousel.js");
require("owl.carousel");
require("./viewport_check.js");
require("./leaflet-map.js");
require("./toggle-accordion.js");
require("./tabs.js");
require("./social-modal.js");
require("./services.js");
require("./galerie.js");
require("./sticky.js");
require("./jobs.js");
// require("./splash.js");
require("./single/services/faq");
require("./single/services/garage");
require("./single/services/other_services");
require("./single/garages/galerie");
require("./single/garages/equipe");
require("./single/garages/service_card_image");

require("./gamme.js");
require("./animations.js");
var jQueryBridget = require("jquery-bridget");
var Masonry = require("masonry-layout");
// make Masonry a jQuery plugin
jQueryBridget("masonry", Masonry, $);

ContactForm.init();
jQuery(function () {
  $('select[name="raison-visite"]').on("change", function () {
    $(
      'select[name="quel-garage-achat"],select[name="quel-garage-entretien"]'
    ).val("Choisissez un garage");
  });
});

if (!document.body.classList.contains("page-template-galeries-photos")) {
  document.addEventListener(
    "wpcf7submit",
    function (event) {
      var quelGarageEntretien =
        document.getElementById("garage-entretien").value;
      var quelGarageAchat = document.getElementById("garage-achat").value;
      var raisonVisite = document.getElementById("raison-visite").value;
      if (raisonVisite == "Raison de votre visite") {
        alert("Veuillez choisir la raison de votre visite s'il vous plaît");
        event.preventDefault();
        return false;
      }
      if (
        quelGarageEntretien == "Choisissez un garage" &&
        quelGarageAchat == "Choisissez un garage"
      ) {
        alert("Veuillez choisir un garage s'il vous plaît");
        event.preventDefault();
        return false;
      }
    },
    false
  );
}

require("./cookies.js");

// var $grid = $('.galsonry').imagesLoaded(function() {
//     console.log('Chargées')
//
// });

function imagesAreLoaded(containerSelector, callback) {
  var images = document.querySelectorAll(containerSelector + " img");
  var totalImages = images.length;
  var loadedImages = 0;

  if (totalImages === 0) {
    // S'il n'y a pas d'images, exécutez le callback immédiatement
    callback();
  }

  images.forEach(function (image) {
    if (image.complete) {
      imageLoaded();
    } else {
      image.addEventListener("load", imageLoaded);
      image.addEventListener("error", imageLoaded); // Gérer également les erreurs
    }
  });

  function imageLoaded() {
    loadedImages++;
    if (loadedImages === totalImages) {
      callback();
    }
  }
}

imagesAreLoaded(".galsonry", function () {
  $(".galsonry").masonry();
});

require("../feed/resources/js/jquery-template");
require("../feed/resources/js/lwsreviews-feed");

$(document).ready(function () {
  // Désactiver temporairement le défilement automatique pour éviter les erreurs
  try {
    let targetId = null;
    
    if (window.location.hash) {
      targetId = window.location.hash;
      window.history.replaceState(null, null, " "); // Enlever temporairement le hash pour stopper le comportement par défaut
    }
    
    // Vérifier si l'élément #rendez-vous existe avant d'appeler scrollIntoView
    const rendezVousElement = document.querySelector("#rendez-vous");
    if (rendezVousElement) {
      // Utiliser setTimeout pour s'assurer que la page est complètement chargée
      setTimeout(function() {
        rendezVousElement.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }

    if (targetId) {
      const target = document.querySelector(targetId);
      if (target) {
        // Utiliser setTimeout pour s'assurer que la page est complètement chargée
        setTimeout(function() {
          target.scrollIntoView({ behavior: 'smooth' });
          window.history.replaceState(null, null, targetId); // Restaurer le hash dans l'URL
        }, 300);
      }
    }
  } catch (e) {
    console.log('Erreur lors du défilement:', e);
  }
});
